import { ReactNode, createContext, useContext, useMemo, useState } from 'react';

export type VersioningContextState = {
  currentVersion: string;
  versions: string[];
  apiUrlName: string;
};

export type VersioningContextAction = {
  setCurrentVersion: (newVersion: string) => void;
  setApiUrlName: (name: string) => void;
};

export const VersioningStateContext = createContext(
  {} as VersioningContextState,
);
export const VersioningActionContext = createContext(
  {} as VersioningContextAction,
);

const VersioningProvider: React.FC<{
  version: string;
  versions: string[];
  apiSlug: string;
  children: ReactNode;
}> = ({ apiSlug, version, versions, children }) => {
  const [currentVersion, setCurrentVersion] = useState<string>(version);
  const [apiUrlName, setApiUrlName] = useState<string>(apiSlug);

  const state: VersioningContextState = {
    currentVersion,
    apiUrlName,
    versions,
  };

  const actions: VersioningContextAction = useMemo(
    () => ({
      setCurrentVersion,
      setApiUrlName,
    }),
    [],
  );

  return (
    <VersioningStateContext.Provider value={state}>
      <VersioningActionContext.Provider value={actions}>
        {children}
      </VersioningActionContext.Provider>
    </VersioningStateContext.Provider>
  );
};

export const useVersioning = () => useContext(VersioningStateContext);
export const useVersioningActions = () => useContext(VersioningActionContext);

export default VersioningProvider;
